/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'graphic-moderate': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<rect pid="0" x="19" y="13" width="4" height="10" rx="1.5" ry="1.5"/><rect pid="1" x="12" y="1" width="4" height="22" rx="1.5" ry="1.5"/><rect pid="2" x="5" y="9" width="4" height="14" rx="1.5" ry="1.5"/>'
  }
})
